import { SummaryRow } from '../../../Summary/SummaryRow';
import { useTranslation } from "react-i18next";

interface Props {
  documentationType?: string;
  uploadedBy?: string;
}

export default function SponsorshipLetter({ documentationType, uploadedBy }: Props) {
    const { t } = useTranslation('forms.finance');
  if (documentationType === undefined) {
    return <div>{t('forms.finance:uploadedBy')} {uploadedBy ? uploadedBy : 'University'}</div>;
  }
  return (
    <>
      <SummaryRow
        key="documentationType"
        label={t('forms.finance:sponsorshipType')}
        fullLabel="What form of documentation do you have for your scholarship?"
        value={documentationType}
      />
    </>
  );
}
